module.exports = __webpack_public_path__ + "img/boletindelitos.b29b5547.jpg";